import { render, staticRenderFns } from "./productionProducts.vue?vue&type=template&id=8c0d4a82&"
import script from "./productionProducts.vue?vue&type=script&lang=js&"
export * from "./productionProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports